module.exports = __webpack_public_path__ + "img/borderRing2White.6b5c7de0.svg";